export const BASE_NAMESPACE = 'OLP_LOCALIZATION'
